import { Component, HostListener, OnInit } from '@angular/core';
import { UserService } from '../../core/services/user.service';
import { PageService } from '../../core/services/page.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/core/services/data.service';
import { Observable } from 'rxjs';
import { LayoutService } from '../layout.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css'],
    standalone: false
})
export class TopbarComponent implements OnInit {
  currentPage = 'Dashboard';
  user: any;
  notificationCount = 0;
  showNotifications = false;
  showProfileMenu = false;
  // selectedCountry!: { code: string, name: string, flag: string };
  selectedCountry: any

  profileData: any;
  profileImg: string = '';
  countryCodeMap: { [key: string]: string } = {
    "Argentina": "ar",
    "Australia": "au",
    "Austria": "at",
    "Belgium": "be",
    "Bosnia": "ba",
    "Brazil": "br",
    "Bulgaria": "bg",
    "Canada": "ca",
    "Chile": "cl",
    "China": "cn",
    "Croatia": "hr",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Estonia": "ee",
    "Finland": "fi",
    "France": "fr",
    "Germany": "de",
    "Herzegovina": "ba", // Bosnia and Herzegovina use the same code
    "Iceland": "is",
    "India": "in",
    "Indonesia": "id",
    "Israel": "il",
    "Italy": "it",
    "Latvia": "lv",
    "Lithuania": "lt",
    "Macedonia": "mk",
    "Malaysia": "my",
    "Mexico": "mx",
    "Moldova": "md",
    "Montenegro": "me",
    "Netherlands": "nl",
    "New Zealand": "nz",
    "Norway": "no",
    "Poland": "pl",
    "Portugal": "pt",
    "Romania": "ro",
    "Serbia": "rs",
    "Singapore": "sg",
    "Slovakia": "sk",
    "Slovenia": "si",
    "South Africa": "za",
    "South Korea": "kr",
    "Spain": "es",
    "Sweden": "se",
    "Switzerland": "ch",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Arab Emirates": "ae",
    "United Kingdom": "gb",
    "United States": "us",
    "USA": "us"
  };
  citizen: any[] = [];
  country: any;
  flagName:any;

  // Shared drawer state (hamburger lives here, the drawer lives in the sidebar)
  isMobileMenuOpen$: Observable<boolean>;

  // Profile hover card
  private profileHover = false;
  private profileCloseTimer: any;

  constructor(
    private userService: UserService,private dataService: DataService, private authService: AuthService, private router: Router,
    private pageService: PageService, private route: ActivatedRoute,  // Inject PageService
    private layoutService: LayoutService
  ) {
    this.isMobileMenuOpen$ = this.layoutService.mobileMenuOpen$;
  }

  ngOnInit() {
    this.getNotification();
     
    this.dataService.profilePic$.subscribe(url => {
      this.profileImg = url;
    });

    this.authService.unreadCount$.subscribe(() => {
      this.getNotification(); // Refresh unread count when triggered
    });

    //this.getEmail = localStorage.getItem("email")
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user;
      this.selectedCountry = {
        code: user.countryCode,
        name: user.countryName,
        flag: user.countryFlag
      };
    });

    // Subscribe to the current page changes
    // this.pageService.currentPage$.subscribe(page => {
    //   console.log('page',page)
    //   // let navItem = localStorage.getItem('navItem')
    //   this.currentPage = page;
    // });

    const savedPage = localStorage.getItem('navItem'); // Set currentPage from localStorage initially if needed
    if (savedPage) {
      this.currentPage = savedPage;
      this.pageService.setCurrentPage(savedPage); // optional
    }

    // Watch for route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navEndEvent = event as NavigationEnd;
        const urlWithoutParams = navEndEvent.urlAfterRedirects.split('?')[0];
        const urlSegment = urlWithoutParams.split('/')[1]; // get top-level route

        const allowedPages = ['dashboard', 'health', 'documents', 'chats', 'settings', 'audittrails', 'notifications', 'calendar', 'connections'];

        if (allowedPages.includes(urlSegment)) {
          //this.currentPage = urlSegment;
          //this.currentPage = urlSegment.charAt(0).toUpperCase() + urlSegment.slice(1);
          
          // Custom mapping for specific routes
          const pageMap: { [key: string]: string } = {
            audittrails: 'Audit Trails',
            notifications: 'Notifications',
            dashboard: 'Dashboard',
            health: 'Health',
            documents: 'Documents',
            chats: 'Chats',
            settings: 'Settings',
            calendar: 'Calendar',
            connections: 'Connections'
          };

          this.currentPage = pageMap[urlSegment] ||
            (urlSegment.charAt(0).toUpperCase() + urlSegment.slice(1));

          this.pageService.setCurrentPage(urlSegment);
          localStorage.setItem('navItem', urlSegment);
          //console.log('Detected currentPage:', urlSegment);
        }
      });

    // Also subscribe to pageService (optional if needed elsewhere)
    this.pageService.currentPage$.subscribe(page => {
      //console.log('pageService emitted page:', page);
    });

    this.getProfile();
    this.getCitizenships();
  }

  getProfile() {
    this.authService.get_digicoffer_profile().subscribe((user: any) => {
      this.profileData = user.data.profile;
    })
    this.authService.get_image().subscribe((img: any) => {
      this.profileImg = img.data.imageUrl;
      localStorage.setItem('profileImg', this.profileImg);
    })
  }

  getCitizenships() {
    this.authService.get_citizenship().subscribe((res: any) => {
      this.citizen = res.data?.citizenships || [];

      // Find only the primary citizenship
      const primary = this.citizen.find((item: any) => item.index === 'citizen_primary');

      if (primary) {
        this.selectedCountry = primary;
        localStorage.setItem('primaryCountry', primary.countryName);
      }
    });
  }

  getCountries() {
    this.authService.getCountries().subscribe((res: any) => {
      this.country = res.data.country;
    });
  }

  getCountryCode(countryName: string): string {
    const name = countryName.trim();
    const code = this.countryCodeMap[name];
    if (!code) {
      console.warn(`Missing country code for: ${name}`);
    }
    return code || '';
  }

  getFlagUrl(countryName: string): string {
    this.flagName = countryName;
    localStorage.setItem('citizenship',this.flagName)
    const code = this.getCountryCode(countryName).toLowerCase();
    return code ? `https://flagcdn.com/${code}.svg` : '';
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    this.showProfileMenu = false;
    this.router.navigate(['/notifications']);
  }

  toggleMobileMenu() {
    this.layoutService.toggleMobileMenu();
  }

  // Click / tap / Enter on the avatar. When the card was just opened by
  // hovering with a mouse, a click keeps it open instead of closing it.
  toggleProfileMenu() {
    if (this.profileHover && this.showProfileMenu) {
      return;
    }
    this.showProfileMenu = !this.showProfileMenu;
    this.showNotifications = false;
  }

  // ---- Profile hover card (mouse devices only; touch uses tap above) ----
  private canHover(): boolean {
    return typeof window !== 'undefined' && !!window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  openProfileCard() {
    if (!this.canHover()) { return; }
    clearTimeout(this.profileCloseTimer);
    this.profileHover = true;
    this.showProfileMenu = true;
    this.showNotifications = false;
  }

  // Small delay so crossing the gap between avatar and card doesn't close it.
  closeProfileCard() {
    if (!this.canHover()) { return; }
    this.profileHover = false;
    clearTimeout(this.profileCloseTimer);
    this.profileCloseTimer = setTimeout(() => {
      this.showProfileMenu = false;
    }, 150);
  }

  closeProfileCardNow() {
    clearTimeout(this.profileCloseTimer);
    this.profileHover = false;
    this.showProfileMenu = false;
  }

  // Tap / click anywhere else closes the card (touch devices and keyboard-opened card)
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.showProfileMenu) { return; }
    const target = event.target as HTMLElement | null;
    if (!target?.closest?.('.user-profile')) {
      this.closeProfileCardNow();
    }
  }

  getNotification() {
    this.authService.get_notifications().subscribe((res: any) => {
      if (!res.error && res.data?.notifications?.length) {
        const allNotifications = res.data.notifications;
        // Count how many notifications have status 'unread'
        this.notificationCount = allNotifications.filter(
          (notif: any) => notif.status === 'unread'
        ).length;
      } else {
        this.notificationCount = 0;
      }
    });
  }

}